// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__RCX0n","title":"styles_title__GLfIG","wrapper":"styles_wrapper__597kF"};